import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PillLink } from "@/components/common/PillLink";
import { JourneyImage } from "@/components/home/JourneyImage";

const ChipLink = ({ to, testid, hint, children }) => (
  <Link to={to} data-testid={testid}
    className="group inline-flex items-center gap-1.5 rounded-full bg-white px-3.5 py-1.5 border border-ink/10 transition-colors duration-200 hover:border-ink hover:bg-mint">
    {children}
    <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
    <span className="sr-only">— {hint}</span>
  </Link>
);

export const Hero = () => {
  return (
    <section className="relative overflow-hidden" aria-labelledby="hero-title" data-testid="hero-section">
      <div className="container-x max-w-[1760px] pb-6 pt-2 lg:pt-3">
        <p className="eyebrow normal-case tracking-normal text-sm">Minds United through Curiosity, Creativity &amp; Inquiry</p>
        <h1 id="hero-title" className="mt-5 text-5xl sm:text-6xl font-semibold leading-[0.98] tracking-tight">
          Curious minds. Bright futures.
        </h1>
        <p className="mt-5 max-w-3xl text-base sm:text-lg leading-relaxed text-ink-soft" data-testid="hero-intro">
          At MUCCI Academy, every question opens a new path, every discovery creates a new connection, and every project
          helps students build their own growing map of knowledge.
        </p>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <PillLink to="/contact#enquire" variant="lemon" arrow data-testid="hero-enquire-button">Make an enquiry</PillLink>
          <PillLink to="/approach" variant="lavender" arrow data-testid="hero-approach-button">How we teach</PillLink>
          <PillLink to="/courses" variant="mint" arrow data-testid="hero-courses-button">Courses</PillLink>
        </div>
        <ul className="mt-4 flex flex-wrap gap-2 text-sm font-bold" aria-label="Ways to learn">
          <li><ChipLink to="/online-timetable" testid="hero-online-timetable-link" hint="see the online class timetable">Online courses</ChipLink></li>
          <li><ChipLink to="/locations" testid="hero-locations-link" hint="see our locations on a map">At MUCCI locations</ChipLink></li>
        </ul>
        <div className="mx-auto mt-10 w-full max-w-[1500px]">
          <JourneyImage name="map" priority testid="hero-journey-image" className="max-w-none" />
        </div>
      </div>
    </section>
  );
};
